import types from "./mutation-types";

export const clearStore = ({ commit }) => {
  commit(types.CLEAR_RIGHTHOLDER_STATEMENTS);
};

export default {
  clearStore,
};
